import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Grid2,
	Divider,
	Switch,
	TextField,
	Typography,
	colors,
} from '@mui/material';

import { SetFormState, UpdateOperator } from '../../../../../../actions/OperatorsActions';

const schema = {
	name: {
		presence: { allowEmpty: false, message: 'is required' },
	},
};

const useStyles = makeStyles((theme) => ({
	root: {},
	saveButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const Details = (props) => {
	const { operator, className, ...rest } = props;

	const classes = useStyles();

	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.operatorsReducer.formState);

	useEffect(() => {
		const errors = validate(formState.values, schema);

		setFormState({
			...formState,
			isValid: !errors,
			errors: errors || {},
		});
	}, [formState.values]);

	const handleChange = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});
	};

	const hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));

	const save = () => {
		dispatch(UpdateOperator(formState.values));
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardHeader title="Operator" />
			<Divider />
			<CardContent>
				<Grid2 container spacing={4}>
					<Grid2 item size={6}>
						<TextField
							error={hasError('name')}
							fullWidth
							helperText={
								hasError('name') ? formState.errors.name[0] : null
							}
							label="Name"
							name="name"
							onChange={handleChange}
							value={formState.values.name || ''}
							variant="outlined"
						/>
					</Grid2>
				</Grid2>
			</CardContent>
			<Divider />
			<CardActions>
				<Button
					className={classes.saveButton}
					onClick={save}
					variant="contained"
				>
					Save Changes
				</Button>
			</CardActions>
		</Card>
	);
};

Details.propTypes = {
	className: PropTypes.string,
	operator: PropTypes.object.isRequired,
};

export default Details;
